import { ClearRounded } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { Button } from "../../../../controls";

const SelectVariantProd = (props) => {
  const { setShowForm, prod, handleSelVarProd, setAlert } = props;
  const [value, setValue] = useState();
  const [activeAttr, setActiveAttr] = useState(0);
  const [selAttrVals, setSelAttrVals] = useState([]);

  useEffect(() => {
    prod &&
      setValue({
        prodType: prod.prodType,
        prodId: prod.id,
        prod: prod,
        qty: 1,
        price: prod.rtlPrice,
        totalPrice: prod.rtlPrice,
        discount: "",
        note: "",
      });
    return () => {};
  }, [prod]);

  const handleClose = () => {
    setShowForm(false);
    setActiveAttr(0);
    setSelAttrVals([]);
  };

  const handleSel = (val) => {
    setSelAttrVals((j) => [...j, val.name]);
    //check is that last attribute?
    if (prod.prodVarAttrs && prod.prodVarAttrs.length === activeAttr + 1) {
      var _selAttrVals = [...selAttrVals, val.name];
      var _selVaraint = prod.prodVariants.find((j) => {
        switch (_selAttrVals.length) {
          case 1:
            return j.attrVal1 === _selAttrVals[0];
          case 2:
            return (
              j.attrVal1 === _selAttrVals[0] && j.attrVal2 === _selAttrVals[1]
            );
          case 3:
            return (
              j.attrVal1 === _selAttrVals[0] &&
              j.attrVal2 === _selAttrVals[1] &&
              j.attrVal3 === _selAttrVals[2]
            );
          default:
            return null;
        }
      });

      if (_selVaraint && _selVaraint.id) {
        handleSelVarProd(
          { ...value, varProdId: _selVaraint.id, varProd: _selVaraint },
          handleClose
        );
      } else {
        handleClose();
        setAlert({
          isOpen: true,
          type: "warning",
          title: "Something is wrong",
          subTitle:
            "Selected variant data not found. Please refresh the page and try again.",
        });
      }
      // handleClose();
    } else setActiveAttr(activeAttr + 1);
  };

  return (
    <div className="p-[15px] grid gap-[15px]">
      <Fragment>
        {prod && prod.prodVarAttrs && (
          <>
            {/* Header */}
            <div className="mb-[5px] flex justify-between items-center">
              <div className="flex items-center gap-[10px]">
                <span className="text-[16px] text-gray-500 mb-[5px] ">
                  {/* Size &gt; Color &gt; Metal */}
                  {prod.prodVarAttrs.map((_attr, i) => (
                    <Fragment key={i}>
                      <span
                        className={`${
                          activeAttr === i && "primary-color font-medium"
                        }`}
                      >
                        {_attr.attr.name}
                      </span>
                      {prod.prodVarAttrs.length - 1 > i && " > "}
                    </Fragment>
                  ))}
                </span>
              </div>
              <div>
                <IconButton onClick={handleClose}>
                  <ClearRounded />
                </IconButton>
              </div>
            </div>
            {/* End Header */}

            {/* Body */}
            <div className="grid gap-[15px]">
              <Grid container spacing={2}>
                <Grid item xs={12} className="pb-[10px]">
                  <span className="gray-color text-[20px]">
                    Select Size for “
                    <span className="font-medium">{prod.name}</span> ”
                  </span>
                </Grid>

                {prod.prodVarAttrs[activeAttr].values.map((attrVal, i) => (
                  <Grid
                    item
                    xs={12}
                    md={
                      prod.prodVarAttrs[activeAttr].values.length === 2 ? 6 : 4
                    }
                    key={i}
                  >
                    <Button
                      onClick={() => handleSel(attrVal)}
                      className="p-[10px] w-[100%] h-[60px] !text-[20px] !font-normal"
                      size="large"
                      variant="text"
                      sx={{ minWidth: "180px" }}
                    >
                      {attrVal.name}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </div>
            {/* End Body */}
          </>
        )}
      </Fragment>
    </div>
  );
};

export default SelectVariantProd;
